import React from "react";

const resolveVariant = (status = "") => {
  const normalized = String(status).toUpperCase();
  if (normalized.includes("DERIVADO")) return "dark";
  if (normalized.includes("SIN_RESPUESTA")) return "warning";
  if (normalized.includes("CERRADO")) return "success";
  if (normalized.includes("LLAMADA")) return "primary";
  if (normalized.includes("CORRECCION")) return "secondary";
  return "info";
};

export default function ProcessStatusBadge({ children }) {
  const variant = resolveVariant(children);
  return <span className={`badge text-bg-${variant}`}>{children || "-"}</span>;
}
